$(document).ready(function(){

  /* =========================
     TESTIMONIAL SLIDER
  ========================= */
  const $testimonial = $('.testimonial-slider');

  if ($testimonial.length && !$testimonial.hasClass('slick-initialized')) {

    $testimonial.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 4000,
      adaptiveHeight: true,
      infinite: true
    });

    // Change big image on slide change
    $testimonial.on('afterChange', function(event, slick, currentSlide){
      const $slide = $testimonial
        .find('.slick-slide[data-slick-index="'+currentSlide+'"] .testimonial-item');

      const image = $slide.data('image');

      if(image){
        $('#mainReviewImage').fadeOut(200, function(){
          $(this).attr('src', image).fadeIn(200);
        });
      }
    });

    // Pause on hover
    $testimonial.on('mouseenter', function () {
      $(this).slick('slickPause');
    });

    $testimonial.on('mouseleave', function () {
      $(this).slick('slickPlay');
    });

    // Set first image
    const firstImage = $('.testimonial-item').first().data('image');
    if(firstImage){
      $('#mainReviewImage').attr('src', firstImage);
    }
  }


  /* =========================
     POPUP OPEN / CLOSE
  ========================= */
  $(document).on('click','#openReviewPopup', function(){
    $('#reviewPopup').fadeIn();
  });

  $(document).on('click','#closeReviewPopup', function(){
    $('#reviewPopup').fadeOut();
  });


  /* =========================
     PORTFOLIO SLIDER
  ========================= */
$('.portfolio-slider').each(function () {

  const $slider = $(this);
  const $arrowWrap = $slider.closest('.review-portfolio').find('.portfolio-arrows');

  if (!$slider.hasClass('slick-initialized')) {

    $slider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      appendArrows: $arrowWrap,
      dots: false,
      infinite: true,
      responsive: [
        {
          breakpoint: 1280,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: 1024,
          settings: { slidesToShow: 4 }
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 2 }
        },
        {
          breakpoint: 601,
          settings: { slidesToShow: 4 }
        },
        {
          breakpoint: 480,
          settings: { slidesToShow: 3 }
        }
      ]
    });

    // Force layout refresh (important for Shopify)
    setTimeout(function () {
      $slider.slick('setPosition');
    }, 300);
  }

});



  /* =========================
     TRUSTED CLIENT THUMB SLIDER
  ========================= */

  const $thumbs = $('.trusted-thumbs .thumb');
  const $track  = $('.thumb-track');
  const $bigImg = $('#trustedBigImage');

  const thumbWidth   = 46;  // thumb size + gap
  const visibleCount = 3;   // visible thumbs
  let currentIndex   = 0;

  if ($thumbs.length && $bigImg.length) {

    function updateSlider(index) {
      const $active = $thumbs.eq(index);
      const bigSrc  = $active.data('big');

      if (!bigSrc) return;

      // Active state
      $thumbs.removeClass('active');
      $active.addClass('active');

      // Update big image
      $bigImg.stop(true,true).fadeOut(150, function () {
        $(this).attr('src', bigSrc).fadeIn(250);
      });

      // Slide thumbs
      const maxOffset   = Math.max(0, $thumbs.length - visibleCount);
      const offsetIndex = Math.min(index, maxOffset);
      const translateX  = -(offsetIndex * thumbWidth);

      $track.css('transform', `translateX(${translateX}px)`);

      currentIndex = index;
    }

    // Thumb click
    $thumbs.on('click', function () {
      updateSlider($(this).data('index'));
    });

    // Next
    $('.thumb-nav.next').on('click', function () {
      let next = currentIndex + 1;
      if (next >= $thumbs.length) next = 0;
      updateSlider(next);
    });

    // Prev
    $('.thumb-nav.prev').on('click', function () {
      let prev = currentIndex - 1;
      if (prev < 0) prev = $thumbs.length - 1;
      updateSlider(prev);
    });

    // Init
    updateSlider(0);
  }

});
